var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "cw-tile",
      class: [_vm.color],
    },
    [
      _c(
        "div",
        {
          staticClass: "preview-image",
          class: [_vm.hasImage ? "" : "default-image"],
          style: _vm.previewImageStyle,
        },
        [
          _vm.hasImageOverlay
            ? _c(
                "div",
                {
                  staticClass: "overlay-text",
                },
                [_vm._t("image-overlay")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasImageOverlayWithActionMenu
            ? _c(
                "div",
                {
                  staticClass: "overlay-action-menu",
                },
                [_vm._t("image-overlay-with-action-menu")],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        _vm.hasDescriptionLink ? "a" : "div",
        {
          tag: "component",
          staticClass: "description",
          attrs: {
            href: _vm.hasDescriptionLink ? _vm.descriptionLink : "",
            title: _vm.descriptionTitle,
          },
        },
        [
          _c(
            "header",
            {
              class: [_vm.icon ? "description-icon-" + _vm.icon : ""],
            },
            [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
          ),
          _vm._v(" "),
          _vm.displayProgress
            ? _c(
                "div",
                {
                  staticClass: "progress-wrapper",
                  attrs: {
                    title: _vm.progressTitle,
                  },
                },
                [
                  _c(
                    "progress",
                    {
                      attrs: {
                        max: "100",
                      },
                      domProps: {
                        value: _vm.progress,
                      },
                    },
                    [_vm._v(_vm._s(_vm.progress))]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "description-text-wrapper",
            },
            [_c("p", [_vm._t("description")], 2)]
          ),
          _vm._v(" "),
          _c("footer", [_vm._t("footer")], 2),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }